export class Guid {

    public static readonly Empty = "00000000000000000000000000000000";

    public static newGuid(): string {
        let res = "";
        const alphabet = "0123456789abcedf";
        for (let i = 0; i < 32; i++) {
            res += alphabet.charAt(Math.floor(Math.random() * alphabet.length));
        }
        return res;
    }

    public static isGuid(value: string): boolean {
        if (!value || (value.length != 32 && value.length != 36)) return false;
        const alphabet = "0123456789abcedf-";
        const val = value.toLowerCase();
        for (let i = 0; i < val.length; i++) {
            if (alphabet.indexOf(val[i]) < 0) {
                return false;
            }
        }
        return true;
    }

}
